import removeQueryParameter from './removeQueryParameter'
import isValidUUIDv4 from './isValidUUIDv4'
import apiFetch from './apiFetch'

import { API_ENDPOINT, STATS_STORAGE_ID } from '../config'
import logGoogleEvent from './logEvent'

const MERGED_PID_STORAGE_ID = 'ows_merged_pid'

export default async function checkPlayerMerge(): Promise<void> {
	// Extract query parameters
	const params = new URLSearchParams(window.location.search)

	// If we have been given a player ID in the query parameters, check to see if we can overwrite the current player ID.
	// We may have to perform a stats merge.
	const playerIdForImport = params.get('pid')
	if (playerIdForImport) console.log('player id for import', playerIdForImport)

	// Remove PID from query parameters (but leave the other parameters)
	removeQueryParameter('pid')

	if (!playerIdForImport || !isValidUUIDv4(playerIdForImport)) return

	const gameId = 'daily5'
	const STATS_ID = STATS_STORAGE_ID(gameId)
	const currentPlayerId = localStorage.getItem('pid')

	if (playerIdForImport === currentPlayerId) return

	logGoogleEvent('migrate', { playerId: playerIdForImport })

	// If we have already merged this player ID for import, then we don't need to do it again
	if (localStorage.getItem(MERGED_PID_STORAGE_ID) === playerIdForImport) return

	const response = await apiFetch(`${API_ENDPOINT}/merge`, 'POST', {
		playerId1: playerIdForImport, // <-- the player ID that we want to import results from
		playerId2: currentPlayerId, // <-- the target player ID that we want to keep
	})

	// NOTE: Before 11/04/2025, we were taking the approach to merge results together, and then overwrite the player ID in
	// localStorage with the one that had been imported. (i.e. taking the player ID from onewordsearch.com and overwriting
	// the one we have at puzzlist.com/onewordsearch). However, that would mean overwriting the player ID that
	// (potentially) other games are using (e.g. puzzlist.com/stackdown). So, instead, we will *keep* the player ID we
	// have (here at puzzlist.com), and just merge results in from the player ID they were using at onewordsearch.com.

	// The difference (in this code) is that we call the merge API with the player IDs the other way around, and we just
	// don't overwrite the player ID in localStorage.

	// We have received stats from the server. We need to update our local stats.
	if (response && response.stats) {
		localStorage.setItem(STATS_ID, JSON.stringify(response.stats))

		// Make a note of this merge, to avoid doing it again unnecessarily.
		localStorage.setItem(MERGED_PID_STORAGE_ID, playerIdForImport)
	}
}
